// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8145) return "assets/js/8145.js";
	// return url for filenames based on template
	return "" + "/assets/js/vendor" + ".js";
};